import React from 'react'
import Button from './common/Button'
import { useModal } from '../hooks/modal'
import { useDeleteRequest } from '../hooks/request'
import { BILLING_PAYMENT_DETAIL } from '../urls'
import ContractPaymentCreate from './ContractPaymentCreate'

const STATUS_CLASS = {
    paid: 'is-success',
    partial: 'is-warning',
    exempt: 'is-light',
    unpaid: 'is-danger',
}

function money(value) {
    return new Intl.NumberFormat('ru-RU').format(value || 0)
}

export default function ContractInvoiceItem({ item, onUpdate }) {
    const deletePayment = useDeleteRequest()

    const [showPaymentModal, hidePaymentModal] = useModal(
        <ContractPaymentCreate
            invoice={item}
            onSuccess={() => {
                hidePaymentModal()
                onUpdate()
            }}
            onCancel={() => hidePaymentModal()} />,
    )

    async function onDeletePayment(paymentId) {
        // eslint-disable-next-line no-restricted-globals, no-alert
        if (!confirm('Удалить платёж? Приход в кассе тоже будет удалён.')) return
        await deletePayment.request({ url: BILLING_PAYMENT_DETAIL.replace('{id}', paymentId) })
        onUpdate()
    }

    return (
        <tr>
            <td>
                {item.companyName}
                <br />
                <span className="has-text-grey is-size-7">
                    {item.moduleLabel}{item.stir ? ` · ${item.stir}` : ''}
                </span>
            </td>
            <td>{money(item.expectedAmount)}</td>
            <td className="has-text-success">{money(item.paid)}</td>
            <td className={item.debt > 0 ? 'has-text-danger' : 'has-text-grey'}>
                {money(item.debt)}
            </td>
            <td>
                <span className={`tag ${STATUS_CLASS[item.status] || 'is-light'}`}>
                    {item.statusLabel}
                </span>
            </td>
            <td>
                {(item.payments || []).map((p) => (
                    <div key={p.id} className="is-size-7">
                        {money(p.amount)} · {p.paidAt} · {p.methodLabel}
                        &nbsp;
                        <button
                            type="button"
                            onClick={() => onDeletePayment(p.id)}
                            className="button is-text is-small has-text-danger">
                            <i className="ion-md-trash" />
                        </button>
                    </div>
                ))}
            </td>
            <td className="has-text-right">
                {item.status !== 'paid' && item.status !== 'exempt' ? (
                    <Button
                        onClick={showPaymentModal}
                        text="Оплата"
                        icon="ion-md-add"
                        className="is-link is-outlined is-small" />
                ) : null}
            </td>
        </tr>
    )
}
